module.exports = __webpack_public_path__ + "static/media/hemmelig.da08ec57.m4a";